<template><div></div></template>
<script>
export default {
  beforeCreate () {
    window.location.href = 'index_f7.html#/'
  }
}
</script>
<!-- only purpose of this component is, to make redirecting work in router -->



// WEBPACK FOOTER //
// src/components/RedirectF7.vue